<div class="comment-input">
  <div class="input-container">
    <mat-form-field appearance="outline" class="comment-textarea">
      <textarea
        #commentTextarea
        matInput
        [formControl]="commentControl"
        [placeholder]="
          isEditMode ? ('translations.comments.actions.editComment' | transloco) : ('translations.comments.actions.addComment' | transloco)
        "
        [rows]="isEditMode ? 4 : 2"
        (focus)="onFocus()"
        (keydown.escape)="onEscape()"
        (keydown.enter)="onEnterKey($event)"
        (input)="onInput()"
      >
      </textarea>
    </mat-form-field>

    <button
      mat-icon-button
      class="send-btn"
      color="primary"
      (click)="onSubmit()"
      [disabled]="commentControl.invalid || isLoading"
      [attr.aria-label]="'translations.global.button.send' | transloco"
    >
      <mat-icon>send</mat-icon>
    </button>
  </div>
</div>
